@if (maintenanceMode) {
<div class="maintenance-page">
  <div class="maintenance-card" role="alert" aria-live="polite">
    <img src="assets/logo.svg" alt="ZGRANE GRONO Logo" style="height:90px;vertical-align:middle;" />
    <p class="maintenance-subtitle">Przerwa techniczna</p>
    <p class="maintenance-message">{{ maintenanceMessage }}</p>
    @if (maintenancePlanningTime) {
    <div class="maintenance-time">
      @if (maintenancePlanningTime?.start) {
      <div>Rozpoczęcie prac serwisowych: {{ $safeNavigationMigration(maintenancePlanningTime?.start) | date:'yyyy-MM-dd HH:mm' }}</div>
      }
      @if (maintenancePlanningTime?.end) {
      <div>Planowane zakończenie prac: {{ $safeNavigationMigration(maintenancePlanningTime?.end) | date:'yyyy-MM-dd HH:mm' }}</div>
      }
    </div>
    }
    @if (showMaintenanceRefresh) {
    <button type="button" class="maintenance-refresh" (click)="refreshPage()" aria-label="Odśwież stronę">
      <mat-icon aria-hidden="true">refresh</mat-icon>
      Odśwież stronę
    </button>
    }
  </div>
</div>
} @else {
@if (!isAdminRoute && !isSupportRoute) {
<div class="toolbar-container">
  <!-- Toolbar -->
  <mat-toolbar color="primary" class="toolbar" role="banner">
    <div class="left-section">
      <span class="logo">
        <a routerLink="/" tabindex="0" style="display:inline-block;"><img src="assets/logo.svg" alt="ZGRANE GRONO Logo"
            style="height:90px;vertical-align:middle;" /></a>
      </span>
      <!-- Hamburger for mobile -->
      @if (isMobile) {
      <button aria-label="Otwórz menu nawigacji" aria-expanded="false" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon class="hamburger" aria-hidden="true">menu</mat-icon>
      </button>
      }
      @if (!isMobile) {
      <div style="cursor: pointer;" class="menu-links">
        @for (item of menuItems; track item; let i = $index) {
        <a class="custom-links" [routerLinkActiveOptions]="{ exact: false }" routerLinkActive="is-active"
          tabindex="2 + i" style="cursor: pointer !important;" [routerLink]="item.link">{{ item.label
          }}</a>
        }
      </div>
      }
    </div>
    @if (isMobile) {
    <div class="right-section">
      @if (!isNarrow) {

      <button mat-icon-button tabindex="31" aria-label="Szukaj" (click)="goTo('/szukaj')" class="search-icon">
        <mat-icon aria-hidden="true">search</mat-icon>
      </button>
      @if (false && showInstallPwa) {
      <button tabindex="31" mat-icon-button aria-label="Zainstaluj aplikację" (click)="goTo('/aplikacja')"
        class="pwa-install-icon" style="margin-right: 8px;">
        <mat-icon aria-hidden="true">download</mat-icon>
      </button>
      }
      @if (!isLoggedIn) {
      <button mat-icon-button aria-label="Przejdź do logowania" tabindex="32" (click)="goTo('/logowanie')">
        <mat-icon aria-hidden="true">person</mat-icon>
      </button>
      }
      @if (isLoggedIn) {
      <button mat-icon-button aria-label="Panel użytkownika" tabindex="33" (click)="goTo('/dashboard')">
        <mat-icon aria-hidden="true">settings</mat-icon>
      </button>
      }
      }
    </div>
    }
    @if (!isMobile) {
    <div class="right-section">

      <button mat-icon-button tabindex="31" aria-label="Szukaj" (click)="goTo('/szukaj')" class="search-icon">
        <mat-icon aria-hidden="true">search</mat-icon>
      </button>
      @if (false && showInstallPwa) {
      <button tabindex="32" mat-icon-button aria-label="Zainstaluj aplikację" (click)="goTo('/aplikacja')"
        class="pwa-install-icon" style="margin-right: 8px;">
        <mat-icon aria-hidden="true">download</mat-icon>
      </button>
      }
      <!-- Show Logowanie and Rejestracja if the user is not logged in -->
      @if (!isLoggedIn) {
      <button mat-raised-button tabindex="33" class="custom-button" (click)="goTo('/logowanie')">Logowanie</button>
      <button mat-raised-button tabindex="34" class="custom-button" (click)="goTo('/rejestracja')">Złóż wniosek</button>
      } @else {
      <!-- Admin session indicator -->
      @if (hasAdminSession) {
      <button tabindex="35" mat-icon-button
        matTooltip="Masz aktywną sesję administratora - kliknij aby przejść do panelu admin" (click)="goToAdmin()"
        class="admin-session-indicator">
        <mat-icon>admin_panel_settings</mat-icon>
      </button>
      }
      <button mat-raised-button tabindex="36" class="custom-button" (click)="goTo('/dashboard')">Panel</button>
      <button mat-raised-button tabindex="37" class="custom-button" (click)="logout()">Wyloguj</button>
      }
      <!-- Show Logout and Dashboard if the user is logged in -->
    </div>
    }
  </mat-toolbar>
</div>
<div class="page-container " [ngClass]="{ 'full-width': fullWidthPage }">
  <div class="main-content-holder">
    @if (maintenancePlanning) {
    <div class="maintenance-planning-banner" role="status" aria-live="polite">
      <mat-icon aria-hidden="true">info</mat-icon>
      <div class="maintenance-planning-text">
        <div>Zaplanowane prace serwisowe w aplikacji.</div>
        @if (maintenancePlanningTime?.start || maintenancePlanningTime?.end) {
        <div>
          @if (maintenancePlanningTime?.start) {
          <span>Start: {{ $safeNavigationMigration(maintenancePlanningTime?.start) | date:'yyyy-MM-dd HH:mm' }}</span>
          }
          @if (maintenancePlanningTime?.start && maintenancePlanningTime?.end) {
          <span> • </span>
          }
          @if (maintenancePlanningTime?.end) {
          <span>Koniec: {{ $safeNavigationMigration(maintenancePlanningTime?.end) | date:'yyyy-MM-dd HH:mm' }}</span>
          }
        </div>
        }
      </div>
    </div>
    }
    <main class="main-content" id="main-content" tabindex="-1" role="main">
      <!--
          <div *ngIf="pageTitle.length > 0"  class="app-title">
            <h1>{{ pageTitle }}</h1>
            <div *ngIf="pageIntro.length > 0" class="app-title__description">{{ pageIntro }}</div>
          </div>
          -->
      <app-loader></app-loader>
      <router-outlet></router-outlet>
      @if (showGoBack) {
      <button class="go-back-btn" mat-fab aria-label="Wróć do poprzedniej strony" (click)="goBack()">
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
      </button>
      }
      @if (showGoTop) {
      <button class="go-top-btn" mat-fab aria-label="Przewiń do góry strony" (click)="scrollToTop()">
        <mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon>
      </button>
      }
    </main>
  </div>

  <!-- Invisible live region for screen readers -->
  <div aria-live="polite" aria-atomic="true" class="sr-only" id="live-announcer"></div>
</div>
<div class="footer-container">

  <ng-container>
    <div class="mobile-footer-dropdown">
      <div class="section">
        <img src="assets/logo.svg" alt="ZGRANE GRONO" style="vertical-align:middle;" />
        <div class="version-number">
          Wersja {{ appVersion }} <br />
          <a class="footer-link" (click)="clearData()">Wyczyść pamięć podręczną</a><br />
          <a class="footer-link" (click)="toggleWcagMode()">Włącz/Wyłącz tryb WCAG (wysoki kontrast)</a><br />
        </div>
      </div>
      <div class="section">
        O programie
        <br><br>
        <a [routerLink]="['/tresc', 'Program_Zgrane_Grono']" style="text-decoration:none; color:inherit;">ZGrane
          Grono</a>
         @if (false || showInstallPwa) {
          <br>
          <a [routerLink]="['/aplikacja']" style="text-decoration:none; color:inherit;">Zainstaluj aplikację</a>
        }
        <br>
    
        <a [routerLink]="['/wiadomosci']" style="text-decoration:none; color:inherit;">
          Aktualności
        </a>
        <br />
        <a [routerLink]="['/informacje_o_karcie']" style="text-decoration:none; color:inherit;">Informacje o
          karcie</a>
        <br>
        <a [routerLink]="['/kontakt']" style="text-decoration:none; color:inherit;">Kontakt</a>
      </div>
      <div class="section">
        Partnerzy<br>
        <br>
        <a [routerLink]="['/zostan-naszym-partnerem']" style="text-decoration:none; color:inherit;">Zostań naszym
          Partnerem</a>
        <br>
        <a [routerLink]="['/partnerzy']" style="text-decoration:none; color:inherit;">Partnerzy programu</a>
        <br>
        <a [routerLink]="['/oferty']" style="text-decoration:none; color:inherit;">Oferty partnerów</a>
        
        <!--
        <br>
        <a [routerLink]="['/nagrody-za-punkty']" style="text-decoration:none; color:inherit;">
          Nagrody za punkty
        </a>
      -->

      </div>
      <div class="section">
        Informacje<br>
        <br>
        <a [routerLink]="['/tresc', 'Regulamin']" style="text-decoration:none; color:inherit;">Regulamin</a>
        <br>
        <a [routerLink]="['/tresc', 'Polityka_prywatnosci']" style="text-decoration:none; color:inherit;">Polityka
          prywatności</a>
        <br>
        <a [routerLink]="['/tresc', 'paczki']" style="text-decoration:none; color:inherit;">
          Paczki powitalne
        </a>
        <br>
        <a [routerLink]="['/tresc', 'pliki_do_pobrania']" style="text-decoration:none; color:inherit;">
          Pliki do pobrania
        </a>
      </div>
      @if (false && showInstallPwa) {
      <div class="section install-pwa">
        <div class="install-pwa__label">📲 Zainstaluj aplikację<br>na Android i iOS</div>
        <!--
        <button mat-raised-button class="install-pwa__btn" (click)="goTo('/aplikacja')">
          <mat-icon aria-hidden="true">download</mat-icon>
          Zainstaluj aplikację
        </button>
      -->


        <app-pwa-installer></app-pwa-installer>
      </div>
      }

    </div>
          <div class="copyright">
        © 2026 Zielona Góra
      </div>
  </ng-container>

  <ng-template #desktopFooter>
    <mat-toolbar color="primary" class="footer-content" role="contentinfo">
      <div class="section">
        <img src="assets/logo.svg" alt="ZGRANE GRONO" style="vertical-align:middle;" />
        <div class="version-number">
          Wersja {{ appVersion }}<br />
          <button mat-button (click)="clearData()">Wyczyść pamięć podręczną</button>
          <button mat-button (click)="refreshPage()">Odśwież</button>
          <button mat-button tabindex="30" aria-label="Dostępność WCAG" (click)="toggleWcagMode()"
            [class.wcag-active]="wcagMode" title="Tryb dużych czcionek i wysokiego kontrastu">
            <mat-icon class="aa-icon">accessibility</mat-icon> wysoki kontrast
          </button>

        </div>
      </div>
      <div class="section">
        O programie
        <br><br>
        <a [routerLink]="['/tresc', 'Program_Zgrane_Grono']" style="text-decoration:none; color:inherit;">
          ZGrane Grono
        </a>
        <br>
        <!--
        <a [routerLink]="['/tresc', 'Informacje_o_karcie']" style="text-decoration:none; color:inherit;">
          Informacje o karcie`
        </a><br>
      -->
        <a [routerLink]="['/kontakt']" style="text-decoration:none; color:inherit;">
          Kontakt
        </a>
      </div>
      <div class="section">
        Partnerzy<br>
        <br>
        <a [routerLink]="['/zostan-naszym-partnerem']" style="text-decoration:none; color:inherit;">
          Zostań naszym Partnerem
        </a>
        <br>
        <a [routerLink]="['/wiadomosci']" style="text-decoration:none; color:inherit;">
          Aktualności
        </a>
        <br>
        <a [routerLink]="['/partnerzy']" style="text-decoration:none; color:inherit;">
          Partnerzy programu
        </a>
        <br>
        <a [routerLink]="['/oferty']" style="text-decoration:none; color:inherit;">
          Oferty partnerów
        </a>
        <!--
        <a [routerLink]="['/nagrody-za-punkty']" style="text-decoration:none; color:inherit;">
          Nagrody za punkty
        </a>
        -->
      </div>
      <div class="section">
        Informacje<br>
        <br>
        <a [routerLink]="['/tresc', 'Regulamin']" style="text-decoration:none; color:inherit;">
          Regulamin
        </a>
        <br>
        <a [routerLink]="['/tresc', 'Polityka_prywatnosci']" style="text-decoration:none; color:inherit;">
          Polityka prywatności
        </a>
        <br>
        <a [routerLink]="['/tresc', 'paczki']" style="text-decoration:none; color:inherit;">
          Paczki powitalne
        </a>
        <br>
        <a [routerLink]="['/tresc', 'pliki_do_pobrania']" style="text-decoration:none; color:inherit;">
          Pliki do pobrania
        </a>

      </div>
    </mat-toolbar>

  </ng-template>

</div>

<!-- Mobile menu definition -->
<mat-menu #menu="matMenu">
  @if (isNarrow) {
  <div class="mobile-menu-header" (click)="$event.stopPropagation()">

    <button mat-icon-button tabindex="-1" aria-label="Szukaj" (click)="goTo('/szukaj'); $event.stopPropagation()"
      class="search-icon">
      <mat-icon aria-hidden="true">search</mat-icon>
    </button>
    @if (false && showInstallPwa) {
    <button mat-icon-button tabindex="-1" aria-label="Zainstaluj aplikację"
      (click)="goTo('/aplikacja'); $event.stopPropagation()" class="pwa-install-icon">
      <mat-icon aria-hidden="true">download</mat-icon>
    </button>
    }
    @if (!isLoggedIn) {
    <button mat-icon-button tabindex="-1" aria-label="Przejdź do logowania"
      (click)="goTo('/logowanie'); $event.stopPropagation()">
      <mat-icon aria-hidden="true">person</mat-icon>
    </button>
    }
    @if (isLoggedIn) {
    <button mat-icon-button tabindex="-1" aria-label="Panel użytkownika"
      (click)="goTo('/dashboard'); $event.stopPropagation()">
      <mat-icon aria-hidden="true">settings</mat-icon>
    </button>
    }
  </div>
  }
  @if (!isLoggedIn) {
  <button mat-menu-item [routerLink]="'/rejestracja'">Złóż wniosek</button>
  <button mat-menu-item [routerLink]="'/logowanie'">Logowanie</button>
  } @else {
  <button mat-menu-item (click)="logout()">Wyloguj</button> 
  <button mat-menu-item (click)="goTo('/dashboard')">Panel użytkownika</button>  
  <button mat-menu-item [routerLink]="'/karta'">Twoja karta</button>
  
  }
  @if (isLoggedIn;) {
  
}
  @for (item of menuItems; track item) {
  <button mat-menu-item [routerLink]="item.link">
    {{ item.label }}
  </button>
  }
  <button mat-menu-item (click)="goTo('/szukaj')">Szukaj na stronie</button>
  @if (showInstallPwa) {
  <button mat-menu-item aria-label="Zainstaluj aplikację" (click)="goTo('/aplikacja')">
    Zainstaluj aplikację
  </button>


  }
</mat-menu>

} @else {
@if (isAdminRoute) {
<router-outlet></router-outlet>
} @else {
<router-outlet></router-outlet>
}
}
}